import Notification from '@rio-cloud/rio-uikit/Notification';
import React, { useEffect, useState } from 'react';
import { getVariablesAll, saveChallenge, updateChallenge } from '../../../../services/challenges';
import { EChallengesType, ECriterion, EPillar, IChallenges } from '../../../../types/challenges';
import EditForm from './EditForm';
import EditHeader from './EditHeader';

const criterionOptions = [
  { label: 'Selecione...', value: '' },
  { label: 'Menor ou Igual', value: ECriterion.LESS_EQUAL },
  { label: 'Maior ou Igual', value: ECriterion.GREATER_EQUAL },
  { label: 'Igual', value: ECriterion.EQUAL },
  { label: 'Diferente', value: ECriterion.DIFFERENT },
  { label: 'Entre', value: ECriterion.BETWEEN },
];

const pillarOptions = [
  { label: 'Selecione...', value: '' },
  { label: 'SECURITY', value: EPillar.SECURITY },
  { label: 'ESG', value: EPillar.ESG },
  { label: 'PREDICTIVE', value: EPillar.PREDICTIVE },
  { label: 'SAFE', value: EPillar.SAFE },
];

const typeOptions = [
  { label: 'Selecione...', value: '' },
  { label: 'Personalizado', value: EChallengesType.PERSONALIZED },
  { label: 'Padrão', value: EChallengesType.DEFAULT },
];

interface EditProps {
  onBack: () => void;
  mode: 'create' | 'edit';
  challenge?: IChallenges;
}

const initialForm = {
  name: '',
  description: '',
  criterion: '' as ECriterion | '',
  criterionValue: 0,
  criterionSecondValue: 0,
  pillar: '' as EPillar | '',
  variableId: 1,
  points: 0,
  uniqueExecute: false,
  active: true,
  validUntil: '',
  type: '' as EChallengesType | '',
};

const Edit: React.FC<EditProps> = ({ onBack, mode, challenge }) => {
  const [form, setForm] = useState(initialForm);
  const [optionsVariables, setOptionsVariables] = useState<any[]>([]);

  const handleFormChange = (field: keyof typeof initialForm, value: any) => {
    setForm(prev => ({ ...prev, [field]: value }));
  };

  useEffect(() => {
    const fetchVariables = async () => {
      try {
        const variablesData = await getVariablesAll();
        setOptionsVariables(variablesData);
      } catch (error) {
        console.error('Erro ao buscar variáveis:', error);
        Notification.error('Não foi possível carregar as variáveis.');
        setOptionsVariables([]);
      }
    };

    fetchVariables();
  }, []);


  useEffect(() => {
    if (mode === 'edit' && challenge) {
      setForm({
        name: challenge.name || '',
        description: challenge.description ?? '',
        criterion: challenge.criterion || '',
        criterionValue: challenge.criterionValue || 0,
        criterionSecondValue: challenge.criterionSecondValue || 0,
        pillar: challenge.pillar || '',
        variableId: challenge.variableId || 0,
        points: challenge.points || 0,
        uniqueExecute: challenge.uniqueExecute || false,
        active: challenge.active || true,
        validUntil: challenge.validUntil || '',
        type: challenge.type || '',
      });
    } else if (mode === 'create') {
      setForm(initialForm);
    }
  }, [mode, challenge]);

  const handleSubmit = async () => {

    if (!form.criterion || !form.pillar) {
      Notification.error('Por favor, preencha todos os campos obrigatórios.');
      return;
    }

    if (form.variableId <= 0) {
      Notification.error('Escolha uma variável válida antes de salvar.');
      return;
    }


    const payloadBase: Omit<IChallenges, 'id'> = {
      name: form.name,
      description: form.description,
      criterion: form.criterion as ECriterion,
      criterionValue: form.criterionValue,
      criterionSecondValue: form.criterionSecondValue,
      pillar: form.pillar as EPillar,
      variableId: form.variableId,
      points: form.points,
      uniqueExecute: form.uniqueExecute,
      active: form.active,
      validUntil: form.validUntil,
      type: EChallengesType.PERSONALIZED,
    };

    try {
      if (mode === 'create') {
        await saveChallenge(payloadBase);
        Notification.success('Desafio criado com sucesso!');
      } else if (mode === 'edit' && challenge) {
        const payloadWithId: IChallenges = {
          id: challenge.id,
          ...payloadBase,
        };
        await updateChallenge(challenge.id.toString(), payloadWithId);
        Notification.success('Desafio atualizado com sucesso!');
      }

      onBack();
    } catch (err: any) {
      Notification.error(err?.response?.data?.error || err?.message || 'Erro ao salvar desafio.');
    }
  };

  return (
    <div className="min-h-screen text-color-info ">
      <div className="width-70pct margin-x-auto padding-50">
        <div className="margin-top-40 margin-bottom-32 padding-y-10">
          <EditHeader mode={mode} />
        </div>
        <div className="panel panel-default panel-body shadow-default rounded text-color-info">
          <EditForm
            form={form}
            onFormChange={handleFormChange}
            criterionOptions={criterionOptions}
            pillarOptions={pillarOptions}
            variableOptions={optionsVariables}
            onBack={onBack}
            onSubmit={handleSubmit}
          />
        </div>
      </div>
    </div>
  );
};

export default Edit; 